import styled from "styled-components";

export const Container = styled.div`
  max-width: 90%;
  margin: 0 auto;
`;

export const Title = styled.h1`
  text-align: center;
  color: #4a7094;
  font-weight: bold;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const ButtonLine = styled.button`
  border: none;
  cursor: pointer;
  padding: 10px 18px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 0;
  color: white;
  background-color: ${(props) =>
    props.isActive ? "#4a7094" : "#9db3c0"};
  transition: 0.3s;
  box-shadow: ${(props) =>
    props.isActive ? "0 4px 8px rgba(0,0,0,0.2)" : "none"};

  &:hover {
    background-color: #4a7094;
  }
`;

export const ButtonDescription = styled.span`
  text-transform: capitalize;
`;

export const ContentContainer = styled.div`
  width: 100%;
`;

export const ItemsContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 0;
  padding: 10px;
  border: 1px solid #d7e1ea;
`;

export const ChecklistGrid = styled.div`
  width: 100%;
  color: #4a7094;
  display: grid;
  grid-template-columns: 1fr; /* mobile */
  row-gap: 8px;
  column-gap: 16px;
  justify-items: start;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ChecklistItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-block: 6px;
`;
